export enum PortfolioBlocksEnum {
	PORTFOLIO_VALUE = 'portfolioValue',
	PROFITABILITY = 'profitability',
	PORTFOLIO_VALUATION = 'portfolioValuation',
	RISK_LEVEL = 'riskLevel',
}
